import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";

const AllProducts = () => {
    const Category = [
        {
            id: 1,
            name: "Mountain Due",
            category: 'Beverage',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 2,
            name: "Mountain Due",
            category: 'Beverage',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 3,
            name: "Mountain Due",
            category: 'x',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 4,
            name: "Mountain Due",
            category: 'Beverage',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 5,
            name: "Mountain Due",
            category: 'y',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 6,
            name: "Mountain Due",
            category: 'x',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        },
        {
            id: 7,
            name: "Mountain Due",
            category: 'Beverage',
            barCode: 'E-83234254',
            supplier: 'Pran',
            purchasePrice: '10tk',
            salesPrice: '15tk',
            purchaseDate: '10 June Fri 2022'
        }
    ];

    const [productCategory, setProductCategory] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [backup, setBackup] = useState([]);
    const { register, handleSubmit } = useForm();
    let [selectedItem, setSelectedItem] = useState(0);
    const selectAll = useRef(null);

    useEffect(() => {
        setProductCategory(Category);
        setBackup(Category);
    }, []);

    
    const checkUncheckHandler = (e) => {
        const { id, checked } = e.target;

        if(id === 'allSelect'){
            let i = 0;
            let tempData = productCategory.filter((user)=> user.category.toLowerCase().includes(filterValue)).map(item => {
                if(checked){
                    setSelectedItem(++i);
                }else{
                    setSelectedItem(0);
                }
                return {...item, isChecked: checked}
            });
            const restData = backup.filter((user)=> !user.category.toLowerCase().includes(filterValue));
            setProductCategory([...tempData, ...restData]);
        }else{
            if(checked){
                selectAll.current.checked = true;
                selectAll.current.indeterminate = true;
                setSelectedItem((prev) => {
                    if(prev === (productCategory.length - 1)){
                        selectAll.current.indeterminate = false;
                        selectAll.current.checked = true;
                    };
                    return prev+1;
                });
            }else{
                setSelectedItem((prev) => {
                    if(prev > 1) selectAll.current.indeterminate = true;
                    
                    if(prev === 1) selectAll.current.indeterminate = false;
                    if((prev-1) === 0) selectAll.current.checked = false;
                    
                    return prev-1;
                });
            };
            
            let tempCategory = productCategory.map(item => item.id === parseInt(id) ? {...item, isChecked: checked} : item);
            setProductCategory(tempCategory);
        }
    };


    const deleteHandler = ({categoryIds}) => {
        console.log(categoryIds);
        const newCategory = productCategory.filter(item => !categoryIds.includes(item.id.toString()));
        setFilterValue('');
        setProductCategory(newCategory);
        selectAll.current.indeterminate = false;
        selectAll.current.checked = false;
        setSelectedItem(0);
    }

    return (
        <div className='container mx-auto px-5 mt-10'>
            <h1 className="text-xl font-semibold text-gray-700 mb-5">All <span className="text-3xl text-[#e74c3c]">Products!</span></h1>
            <div className="sm:flex sm:justify-between sm:items-center my-4">
                <select className="select bg-gray-100 text-black select-bordered select-sm max-w-xs" value="category" onChange={(e)=>{setFilterValue(e.target.value)}}>
                    <option>Filter by category name</option>
                    <option value="beverage">Beverage</option>
                    <option value="x">x</option>
                    <option value="y">y</option>
                </select>
                <>
                    {
                        selectedItem > 0 &&
                        <div className="flex justify-between items-center pt-3 sm:pt-0 sm:gap-4">
                            <p className="text-sm">{selectedItem} selected</p>
                            <button type="submit" className="btn btn-sm btn-square bg-gray-100 border-gray-300 text-black hover:bg-gray-200 hover:border-gray-400" form="tableItemSelector">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    }
                </>
            </div>
            <form className="overflow-x-auto" id="tableItemSelector" onSubmit={handleSubmit(deleteHandler)}>
                <table  data-theme="light" className="table table-compact w-full">
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" id='allSelect' value={undefined} {...register("categoryIds")} onChange={checkUncheckHandler} className="checkbox" ref={selectAll} />
                            </th>
                            <th>Product Name</th> 
                            <th>Category</th> 
                            <th>Bar Code</th> 
                            <th>Supplier</th> 
                            <th>Purchase Price</th> 
                            <th>Sales Price</th>
                            <th>Purchase Date</th>
                        </tr>
                    </thead> 
                    <tbody>
                        {
                            productCategory.filter(item => item.category.toLowerCase().includes(filterValue)).map(item =>
                                <tr key={item.id}>
                                    <th>
                                        <input type="checkbox" id={item.id} value={item.id} {...register("categoryIds")} checked={item?.isChecked || false} onChange={checkUncheckHandler} className="checkbox" />
                                    </th>
                                    <td>{item.name}</td> 
                                    <td>{item.category}</td> 
                                    <td>{item.barCode}</td> 
                                    <td>{item.supplier}</td> 
                                    <td>{item.purchasePrice}</td>
                                    <td>{item.salesPrice}</td> 
                                    <td>{item.purchaseDate}</td>
                                </tr>)
                        }
                    </tbody>
                </table>
            </form>
        </div>
    );
};

export default AllProducts;